module.exports = __webpack_public_path__ + "fonts/slick.d41f55a.ttf";